import { useEffect, useState } from "react";

export default function AdminInbox() {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');

  // Hent meldinger
  async function fetchMessages() {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/inbox`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (!res.ok) throw new Error();
      setMessages(await res.json());
    } catch {
      setError('Kunne ikke hente meldinger');
    }
  }

  useEffect(() => { fetchMessages(); }, []);

  // Marker som lest (kalles når man velger en melding som ikke er lest)
  async function markAsRead(msg) {
    if (msg.isRead) return;
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/inbox/${msg.id}/read`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setMessages(ms =>
        ms.map(m => m.id === msg.id ? { ...m, isRead: true } : m)
      );
    } catch { /* ignorer feil */ }
  }

  // Når man klikker på en melding
  function handleSelect(msg) {
    setSelected(msg);
    markAsRead(msg);
  }

  return (
    <div className="flex gap-6 p-4 min-h-[500px]">
      {/* VENSTRE: Liste */}
      <div className="w-1/2 border-r pr-4">
        <h2 className="text-xl font-semibold mb-3">Innboks</h2>
        {error && <div className="text-red-500 mb-2">{error}</div>}
        <ul className="space-y-2 max-h-[600px] overflow-auto">
          {messages.map(msg => (
            <li
              key={msg.id}
              onClick={() => handleSelect(msg)}
              className={`cursor-pointer p-2 rounded border flex justify-between items-center
                ${selected?.id === msg.id ? "border-[#000099] bg-blue-50" : "border-gray-100"}
                ${!msg.isRead ? "font-bold bg-yellow-50" : ""}`
              }
            >
              <div>
                <div>
                  {msg.User?.name || msg.User?.email || "Ukjent"} <span className="text-xs text-gray-500">({msg.MessageTopic?.name || "–"})</span>
                </div>
                <div className="text-xs text-gray-400">{new Date(msg.createdAt).toLocaleString("no-NO")}</div>
              </div>
              <div>
                {msg.isRead
                  ? <span className="text-green-600 text-xs">Lest</span>
                  : <span className="text-red-500 text-xs">Ulest</span>
                }
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* HØYRE: Detaljvisning */}
      <div className="w-1/2">
        {selected ? (
          <div className="bg-gray-50 border p-6 rounded-xl shadow-lg">
            <div className="mb-3">
              <span className="text-xs text-gray-500">{new Date(selected.createdAt).toLocaleString("no-NO")}</span>
            </div>
            <div className="mb-2">
              <strong>Fra:</strong> {selected.User?.name || selected.User?.email || "Ukjent"}
            </div>
            <div className="mb-2">
              <strong>Kategori:</strong> {selected.MessageTopic?.name || "–"}
            </div>
            <div className="mb-4">
              <strong>Melding:</strong>
              <div className="mt-1 p-2 bg-white border rounded break-words">{selected.message}</div>
            </div>
          </div>
        ) : (
          <div className="text-gray-600 mt-16">Velg en melding for detaljer.</div>
        )}
      </div>
    </div>
  );
}
